import React, { Fragment, useContext, useEffect, useState } from 'react'
import styles from './ModalDetailContainer.module.scss'
import editIcon from '../../images/edit_icon.png'
import { Customer } from '../../models/Customer'
import { trimLongString } from '../../utils/HelperFunctions'
import { Grid } from '@mui/material'
import { DeviceContext } from '../../context/Contexts'

interface Props {
    customer: Customer
    handleAction: (element: Customer) => void
    selectedElementId: number
    handleSaveClick : () => void
    handleCustomerEditClick: () => void
}

export const ModalRowCustomer = ({ handleSaveClick, customer, handleAction, selectedElementId, handleCustomerEditClick }: Props ) => {
    const [ isSelected, setIsSelected ] = useState(false)
    const { isMobile } = useContext(DeviceContext)
    const trimStringAt = isMobile ? 45 : 90

    useEffect(() => {
        setIsSelected(selectedElementId === customer.Id)
    })

    const handleClick = () => {
        handleAction(customer)
        setIsSelected(true)
    }

    return (
        <Fragment>
            <Grid container spacing={2} 
                    className={styles[isMobile ? 'row-mobile' : 'row'] + ' ' + (isSelected ? styles.selected : '')}
                    onClick={() => handleClick()}
                    onDoubleClick={ () => handleSaveClick()}
                    sx={{marginTop: '5px'}} >
                <Grid item xs={2} className={styles.left}>
                    <div>
                    {customer?.Code ?? ''}
                    </div>
                </Grid>
                <Grid item xs={7} className={styles.center}>
                    {trimLongString(customer?.Name, trimStringAt) ?? ''}
                    <br/>
                    <div className={styles['second-row']}>{customer?.TaxNumber ?? ''}</div>
                </Grid>
                <Grid item xs={3} className={styles.right} style={{paddingTop: 0}}>
                    <div className={styles['right']}>
                        <img className={styles['edit-icon']} src={editIcon} alt=''
                            onClick={handleCustomerEditClick}/>
                    </div>
                </Grid>
            </Grid>
        </Fragment>
    )
}